const Checkmark = () => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            fill="currentColor" 
            className="bi bi-check" 
            viewBox="0 0 16 16"
        >
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7 10.293l6.146-6.147a.5.5 0 0 1 .708 0z"></path>
        </svg>
    );
};

export default Checkmark;
